import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { FaApple } from 'react-icons/fa';

/**
 * Pie de página claro (Gris #f8fafc) sin bordes con el logo transparente, botones de descarga de app y la bandera de Chile 🇨🇱
 */
export default function FooterNav() {
  return (
    <footer className="docs-footer" style={{ background: '#f8fafc', border: 'none', color: '#475569', fontSize: '13.5px', marginTop: 'auto' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '48px 24px 28px' }}>
        
        {/* REJILLA DE COLUMNAS DEL FOOTER - SIN BORDES */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '32px',
          paddingBottom: '32px',
          border: 'none'
        }}>
          
          {/* COLUMNA 1: MARCA Y ESTADO DEL SERVICIO */}
          <div style={{ gridColumn: 'span 1', minWidth: '220px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
              <img 
                src="/assets/img/veez_logo_transparent.png" 
                alt="Veez Logo" 
                style={{ width: '26px', height: '26px', objectFit: 'contain' }} 
              />
              <span style={{ fontWeight: 600, fontSize: '16px', color: '#0f172a' }}>
                VeezDocs
              </span>
              <span style={{ background: '#d1fae5', color: '#047857', fontSize: '10px', padding: '2px 6px', borderRadius: '10px', fontWeight: 600, border: 'none' }}>
                v2.0
              </span>
            </div>
            
            <p style={{ fontSize: '13px', lineHeight: 1.6, color: '#64748b', marginBottom: '16px', fontWeight: 300 }}>
              Plataforma de Logística de Última Milla, Despacho Express & Devoluciones Inteligentes en Chile y LATAM.
            </p>

            {/* STATUS BADGE - SIN BORDE */}
            <a 
              href="https://status.veez.cl" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '6px 12px',
                background: '#ffffff',
                border: 'none',
                borderRadius: '20px',
                fontSize: '12px',
                color: '#0f172a',
                textDecoration: 'none'
              }}
              className="status-badge-hover"
            >
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#00bf63', display: 'inline-block', boxShadow: '0 0 0 3px rgba(0, 191, 99, 0.2)' }}></span>
              <span style={{ fontWeight: 500 }}>Sistemas 100% Operativos</span>
            </a>
          </div>

          {/* COLUMNA 2: DOCUMENTACIÓN */}
          <div>
            <h5 style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.8px', color: '#0f172a', fontWeight: 600, marginBottom: '14px' }}>
              Documentación
            </h5>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li>
                <a href="#overview" style={{ color: '#64748b', textDecoration: 'none' }} className="footer-link">
                  Guía de Desarrolladores
                </a>
              </li>
              <li>
                <a href="#post-shipping-quote" style={{ color: '#64748b', textDecoration: 'none' }} className="footer-link">
                  Cotización de Envío API
                </a>
              </li>
              <li>
                <a href="#post-orders" style={{ color: '#64748b', textDecoration: 'none' }} className="footer-link">
                  Creación de Pedidos
                </a>
              </li>
              <li>
                <a href="#webhooks" style={{ color: '#64748b', textDecoration: 'none' }} className="footer-link">
                  Eventos & Webhooks
                </a>
              </li>
            </ul>
          </div>

          {/* COLUMNA 3: PLUGINS E INTEGRACIONES */}
          <div>
            <h5 style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.8px', color: '#0f172a', fontWeight: 600, marginBottom: '14px' }}>
              Integraciones
            </h5>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li>
                <a href="#install-woocommerce" style={{ color: '#64748b', textDecoration: 'none' }} className="footer-link">
                  Plugin WooCommerce
                </a>
              </li>
              <li>
                <a href="#install-shopify" style={{ color: '#64748b', textDecoration: 'none' }} className="footer-link">
                  Conector Shopify
                </a>
              </li>
              <li>
                <a href="#install-odoo" style={{ color: '#64748b', textDecoration: 'none' }} className="footer-link">
                  Addon Odoo ERP
                </a>
              </li>
              <li>
                <a href="#sdk-javascript" style={{ color: '#64748b', textDecoration: 'none' }} className="footer-link">
                  SDKs (@veez monorepo)
                </a>
              </li>
            </ul>
          </div>

          {/* COLUMNA 4: PLATAFORMA VEEZ */}
          <div>
            <h5 style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.8px', color: '#0f172a', fontWeight: 600, marginBottom: '14px' }}>
              Plataforma Veez
            </h5>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li>
                <a href="https://veez.cl" target="_blank" rel="noopener noreferrer" style={{ color: '#64748b', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }} className="footer-link">
                  Sitio Oficial Veez.cl <FiExternalLink size={12} />
                </a>
              </li>
              <li>
                <a href="https://app.veez.cl" target="_blank" rel="noopener noreferrer" style={{ color: '#64748b', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }} className="footer-link">
                  Panel de Comercio <FiExternalLink size={12} />
                </a>
              </li>
              <li>
                <a href="https://veez.cl/contacto" target="_blank" rel="noopener noreferrer" style={{ color: '#64748b', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }} className="footer-link">
                  Soporte Técnico API
                </a>
              </li>
            </ul>
          </div>

          {/* COLUMNA 5: APP MÓVIL (BOTONES DE DESCARGA DE LANDING) */}
          <div style={{ minWidth: '260px', gridColumn: 'span 1' }}>
            <h5 style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.8px', color: '#0f172a', fontWeight: 600, marginBottom: '14px' }}>
              App Móvil
            </h5>
            <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '12px', lineHeight: 1.4, fontWeight: 300 }}>
              Gestiona tus envíos desde cualquier lugar.
            </p>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
              
              {/* Apple App Store Button */}
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  backgroundColor: '#0f172a',
                  color: '#ffffff',
                  padding: '8px 14px',
                  borderRadius: '10px',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  width: 'fit-content'
                }}
              >
                <FaApple size={20} style={{ color: '#ffffff', flexShrink: 0 }} />
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                  <span style={{ fontSize: '8px', lineHeight: 1.1, color: '#94a3b8', fontWeight: 400, letterSpacing: '0.02em' }}>
                    Descargar en la
                  </span>
                  <span style={{ fontSize: '13px', lineHeight: 1.2, color: '#ffffff', fontWeight: 600, letterSpacing: '-0.01em' }}>
                    App Store
                  </span>
                </div>
              </a>

              {/* Google Play Store Button */}
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  backgroundColor: '#0f172a',
                  color: '#ffffff',
                  padding: '8px 14px',
                  borderRadius: '10px',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  width: 'fit-content'
                }}
              >
                <svg viewBox="0 0 512 512" width="18" height="18" style={{ flexShrink: 0 }}>
                  <path fill="#4285F4" d="M47.2 24.6C44 28 42.1 33.3 42.1 40.5v431c0 7.2 1.9 12.5 5.1 15.9l2.4 2.2L282 257.1v-5.5L49.6 22.4l-2.4 2.2z" />
                  <path fill="#FBBC04" d="M362.6 337.8l-80.6-80.7v-5.5l80.6-80.7 1.8 1 95.5 54.3c27.3 15.5 27.3 40.9 0 56.4l-95.5 54.2-1.8 1z" />
                  <path fill="#EA4335" d="M364.4 336.8L282 254.3 47.2 489.6c8.9 9.5 23.7 10.6 40.4 1.1l276.8-153.9z" />
                  <path fill="#34A853" d="M364.4 175.2L87.6 18.3c-16.7-9.5-31.5-8.4-40.4 1.1L282 257.7l82.4-82.5z" />
                </svg>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                  <span style={{ fontSize: '8px', lineHeight: 1.1, color: '#94a3b8', fontWeight: 500, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                    DISPONIBLE EN
                  </span>
                  <span style={{ fontSize: '13px', lineHeight: 1.2, color: '#ffffff', fontWeight: 600, letterSpacing: '-0.01em' }}>
                    Google Play
                  </span>
                </div>
              </a>

            </div>
          </div>

        </div>

        {/* BARRA INFERIOR COPYRIGHT & CHILE FLAG - SIN BORDE */}
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: '20px',
          gap: '12px',
          fontSize: '12.5px',
          color: '#64748b',
          border: 'none'
        }}>
          <div>
            © {new Date().getFullYear()} <strong style={{ color: '#0f172a' }}>Veez</strong> Platform Inc. Todos los derechos reservados.
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <span>Hecho con 💚 para Chile 🇨🇱 & LATAM</span>
          </div>
        </div>

      </div>
    </footer>
  );
}
